import React from "react";
import { motion } from "framer-motion";
import "./Frame1.css";

function Frame1(props) {
  const { className } = props;

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`frame-1 ${className || ""}`}
    >
      <div className="overlap-group4">
        <div className="chart-name-21 poppins-bold-white-16px">Map</div>
      </div>
    </motion.div>
  );
}

export default Frame1;
